import React, { useState } from 'react'
import { Button, Dialog, DialogContent, TextField, CircularProgress } from '@mui/material'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling'
import idDirectory from './idAttributes'

export interface AddCommentModalProps {
    openModal: boolean
    onClose: () => void
    onSubmit: (comment: string) => void
    loadingSubmit: boolean
    testId: string
    modalTitle?: string
    modalSubtitle?: string
    cancelButtonText?: string
    submitButtonText?: string
    disableBackdropClick?: boolean
    isRequiredComment?: boolean
}

const AddCommentModal = ({
    openModal,
    onClose,
    onSubmit,
    loadingSubmit,
    testId,
    modalTitle = 'Add Comment',
    modalSubtitle = 'Comment',
    cancelButtonText = 'Cancel',
    submitButtonText = 'Submit',
    disableBackdropClick = true,
    isRequiredComment = false,
}: AddCommentModalProps) => {
    const { clientTheme } = useThemeStyling()
    const [comment, setComment] = useState<string>('')

    const handleOnClose = () => {
        onClose()
        setComment('')
    }

    return (
        <Dialog
            open={openModal}
            onClose={disableBackdropClick ? () => {} : handleOnClose}
            maxWidth="sm"
            fullWidth
            scroll={'body'}
            id={`${testId}-${idDirectory.dialogMain}`}
        >
            <DialogContent
                className={'emp-addCommentModal-content'}
                id={`${testId}-${idDirectory.dialogContent}`}
            >
                <>
                    <h2
                        className={'emp-addCommentModal-title'}
                        id={`${testId}-${idDirectory.textTitle}`}
                    >
                        {modalTitle}
                    </h2>
                    {modalSubtitle && (
                        <h4
                            className={'emp-addCommentModal-subtitle'}
                            id={`${testId}-${idDirectory.textSubtitle}`}
                        >
                            {modalSubtitle}
                        </h4>
                    )}
                    <TextField
                        variant="outlined"
                        onChange={(e) => setComment(e.target.value)}
                        value={comment}
                        placeholder={`Comment${isRequiredComment ? '*' : ''}`}
                        multiline
                        rows={4}
                        id={`${testId}-${idDirectory.inputTextField}`}
                        className="emp-addCommentModal-textField"
                    />
                    <div className={'emp-addCommentModal-actions'}>
                        <Button
                            className={'emp-addCommentModal-btn'}
                            variant="contained"
                            onClick={handleOnClose}
                            id={`${testId}-${idDirectory.btnCancel}`}
                            sx={clientTheme.buttons.defaultButton.style}
                        >
                            {cancelButtonText}
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={'emp-addCommentModal-btn'}
                            onClick={() => {
                                onSubmit(comment)
                            }}
                            id={`${testId}-${idDirectory.btnSubmit}`}
                            disabled={
                                loadingSubmit || (isRequiredComment && !comment)
                            }
                        >
                            {loadingSubmit ? (
                                <>
                                    Submitting...{' '}
                                    <CircularProgress
                                        className={
                                            'emp-addCommentModal-circularProgress'
                                        }
                                        color="secondary"
                                    />
                                </>
                            ) : (
                                submitButtonText
                            )}
                        </Button>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    )
}

export default AddCommentModal
